/**
 * QuoteAuthorLink — 名言の発言者名を Wikipedia (ja) へのリンクとして描画する。
 *
 * 「プラトン」「ドラッカー」等を見たときに「何した人？」が即座に解消できるよう、
 * 発言者名をクリックすると新規タブで日本語 Wikipedia の該当記事を開く。
 *
 * 設計方針:
 *  - リンク色を強く出さず、装飾は通常テキストとほぼ同じ
 *  - hover 時のみ下線を出し「クリックできる」気配を伝える
 *  - 検索ヒットしない名前でも Wikipedia が検索フォールバックを表示するので URL を直接組む
 */
export function QuoteAuthorLink({ author }: { author: string }) {
  const url = `https://ja.wikipedia.org/wiki/${encodeURIComponent(author)}`
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${author} を Wikipedia で開く`}
      style={{
        fontSize: 12,
        color: 'var(--text2)',
        fontWeight: 500,
        textDecoration: 'none',
        textDecorationThickness: '1px',
        textUnderlineOffset: 2,
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.textDecoration = 'underline')}
      onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
    >
      {author}
    </a>
  )
}
